import React from 'react'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'

export default function BrowserButton(props) {
  return (
    <Button href={props.link} className="btn btn-outline-secondary w-100">
      <h3>
        <small>{props.platformName}</small>
      </h3>
    </Button>
  )
}

BrowserButton.propTypes = {
  link: PropTypes.string,
  platformName: PropTypes.string,
}
